export const pubAdsServiceRefresh = ['controlledByPublisher', 'controlledByYieldbird'] as const

export type PubAdsServiceRefresh = (typeof pubAdsServiceRefresh)[number]
